import { z } from 'zod';
import { ILegalClient } from '../../ILegalClient';
import { GenericLegalTransactionRelationshipMemberSchema } from '../GenericLegalTransactionRelationshipMemberSchema';
import { getEmptyMemberSkeleton } from '../ILegalTransactionRelationshipMember';
import { LegalTransactionRelationshipRoleEnum } from '../LegalTransactionRelationshipRoleEnum';

export const ParentMemberDataSchema = z.object({});

export type IMemberParentData = z.infer<typeof ParentMemberDataSchema>;

export const ParentMemberSchema =
  GenericLegalTransactionRelationshipMemberSchema(
    z.literal(LegalTransactionRelationshipRoleEnum.Parent),
    ParentMemberDataSchema
  );

export type IMemberParent = z.infer<typeof ParentMemberSchema>;

export const getEmptyParentMemberData = (): IMemberParentData => ({
  type: 'parent',
});

export function getEmptyParentMember(
  legalClient: ILegalClient,
  idRelationship: number,
  data?: IMemberParentData
): IMemberParent {
  const member: IMemberParent = {
    ...getEmptyMemberSkeleton(legalClient, idRelationship),
    idRelationshipRole: LegalTransactionRelationshipRoleEnum.Parent,
    data: data || getEmptyParentMemberData(),
  } as IMemberParent;

  return member;
}
